import { render, staticRenderFns } from "./confirmed-action-button.vue?vue&type=template&id=6b158caa&scoped=true&"
import script from "./confirmed-action-button.vue?vue&type=script&lang=js&"
export * from "./confirmed-action-button.vue?vue&type=script&lang=js&"
import style1 from "./confirmed-action-button.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b158caa",
  null
  
)

export default component.exports